import { Component, Inject, HostListener } from '@angular/core';
import {
  MatSnackBarRef,
  MAT_SNACK_BAR_DATA,
} from '@angular/material/snack-bar';

@Component({
  selector: 'thr-techsnackbar',
  templateUrl: './techsnackbar.component.html',
  styleUrls: ['./techsnackbar.component.scss'],
})
export class TechSnackbarComponent {
  constructor(
    public snackBarRef: MatSnackBarRef<TechSnackbarComponent>,
    @Inject(MAT_SNACK_BAR_DATA) public data: any
  ) {}
}
